import {useGTMDispatch} from './react-gtm-hook/index'
import {capitalize} from '../utils/utils'
import {getComponentName} from './utils'

export const useSelectContentTracking = () => {
  const sendDataToGTM = useGTMDispatch()
  const sendSelectContentData = (content) => {
    if (!content) {
      return null
    }

    const schema = content?._meta?.schema
    const component = schema ? getComponentName(schema).replaceAll('-', ' ') : 'component'
    const componentCapitalized = capitalize(component)
    setTimeout(() => {
      try {
        sendDataToGTM({
          event: 'select_content',
          ecommerce: {
            content_id: content?._meta?.name ?? 'Missing content identifier',
            content_type: componentCapitalized ?? 'Missing content type',
          }
        })
      } catch (error) {
        console.error('useSelectContentTracking error within setTimeout: ' + error.message)
      }
    })
  }
  return sendSelectContentData
}